import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=3031224b&"
import script from "./ActionsMenu.vue?vue&type=script&lang=js&"
export * from "./ActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3031224b')) {
      api.createRecord('3031224b', component.options)
    } else {
      api.reload('3031224b', component.options)
    }
    module.hot.accept("./ActionsMenu.vue?vue&type=template&id=3031224b&", function () {
      api.rerender('3031224b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userManagement/ActionsMenu.vue"
export default component.exports